// bootstrap import
// import "bootstrap"

// import Loader from './parts/Loader.js'
// import Navigation from './parts/Navigation.js'
// import Smooth from './parts/Smooth.js'
// import Accordion from './parts/Accordion.js'
// import MouseStalker from './parts/MouseStalker.js'
// import Swiper from 'swiper/bundle'
// import 'swiper/swiper-bundle.css'

// import { gsap } from 'gsap'
// import { ScrollSmoother } from 'gsap/ScrollSmoother'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'

import Splide from '@splidejs/splide'
import '@splidejs/splide/css/core'

// スムーススクロール実装
//----------------------------------------------------
// gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

// ----------------------------------------------------
// ナビゲーション
// ----------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  const hamburger = document.getElementById('js-hamburger')
  const spNav = document.getElementById('js-sp-nav')
  const spLinks = document.querySelectorAll('.sp-nav-list a')

  if (!hamburger || !spNav) return

  // メニューを開閉する関数
  const toggleMenu = () => {
    hamburger.classList.toggle('is-active')
    spNav.classList.toggle('is-active')

    // 背景固定（メニュー開いているときに後ろをスクロールさせない）
    if (spNav.classList.contains('is-active')) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }

  // ボタンクリックイベント
  hamburger.addEventListener('click', () => {
    toggleMenu()
  })

  // リンクをクリックしたらメニューを閉じる
  spLinks.forEach((link) => {
    link.addEventListener('click', () => {
      if (spNav.classList.contains('is-active')) {
        toggleMenu()
      }
    })
  })
})

// ----------------------------------------------------
// 基礎
// ----------------------------------------------------
class IntroSection {
  private items: NodeListOf<HTMLElement>

  constructor() {
    this.items = document.querySelectorAll('.intro-item')
    this.init()
  }

  private init(): void {
    if (this.items.length === 0) return
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new IntroSection()
})

// ----------------------------------------------------
// ローダー未使用時の互換: 旧 id="preload" が残っていると transition が全無効になる
// ----------------------------------------------------
function releasePreloadTransitionLock(): void {
  const body = document.body
  if (body.id === 'preload') {
    body.removeAttribute('id')
  }
  body.classList.remove('is-preloading')
}

// ----------------------------------------------------
// slider
// ----------------------------------------------------
// ========== スライダー・中央拡大のタイミング調整（ここを編集） ==========
/** 横スライドの移動速度（ms） */
const SLIDER_SPEED = 500
/** 中央スライドの枠が大きくなるアニメ速度（ms）。横移動と同程度〜やや短めが自然 */
const SLIDER_SCALE_SPEED = 500
/**
 * 拡大の transition-delay（ms）。
 * マイナスにすると「横移動より早く拡大が進んでいる」ように見える（CSS仕様）。
 * 例: -250 → 拡大開始時点で既に250ms分進んだ状態からアニメ
 * 目安: -(SLIDER_SPEED の 30〜60%) から調整（-150 〜 -300 など）
 */
const SLIDER_SCALE_DELAY = -150
/**
 * true: Splide標準の is-active も移動中に更新
 * false: 移動完了後に is-active（拡大は move イベント側で先に開始するので false でも可）
 */
const SLIDER_UPDATE_ON_MOVE = true
/** 自動再生の切り替え間隔（ms） */
const SLIDER_AUTOPLAY_INTERVAL = 4000
/** 手動操作（ドラッグ・矢印）後、自動再生を再開するまでの待機（ms） */
const SLIDER_AUTOPLAY_RESUME_DELAY = 3000
// ====================================================================

function initExhibitionSlider(): void {
  releasePreloadTransitionLock()
  const sliderEl = document.getElementById('exhibition-splide')
  if (!sliderEl) return

  const slides = sliderEl.querySelectorAll('.splide__slide')
  const slideCount = slides.length
  if (slideCount === 0) return

  const splide = new Splide('#exhibition-splide', {
    type: slideCount > 1 ? 'loop' : 'slide',
    perPage: Math.min(3, slideCount),
    focus: 'center',
    gap: '40px',
    padding: { left: 0, right: '1.2%' },
    pagination: false,
    arrows: true,
    drag: slideCount > 1,
    autoplay: slideCount > 1,
    interval: SLIDER_AUTOPLAY_INTERVAL,
    speed: SLIDER_SPEED,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    pauseOnHover: true,
    pauseOnFocus: true,
    updateOnMove: SLIDER_UPDATE_ON_MOVE,
    reducedMotion: { speed: SLIDER_SPEED, rewindSpeed: SLIDER_SPEED },
    breakpoints: {
      768: {
        perPage: 1,
        gap: '20px',
        padding: { left: 0, right: '1.2%' },
      },
    },
  })

  /** 移動開始と同時に「これから中央になる」スライドへ拡大クラスを付与 */
  const applyEarlyScale = (destIndex: number): void => {
    sliderEl.querySelectorAll('.splide__slide').forEach((slide) => {
      slide.classList.remove('is-scale-early')
    })
    const target = splide.Components.Slides.getAt(destIndex)
    target?.slide.classList.add('is-scale-early')
  }

  let autoplayResumeTimer: ReturnType<typeof setTimeout> | null = null

  /** 手動操作後: 自動再生を止め、一定時間後に再開 */
  const scheduleAutoplayResume = (): void => {
    const autoplay = splide.Components.Autoplay
    if (!autoplay) return

    autoplay.pause(false)

    if (autoplayResumeTimer !== null) {
      clearTimeout(autoplayResumeTimer)
    }

    autoplayResumeTimer = setTimeout(() => {
      autoplay.play()
      autoplayResumeTimer = null
    }, SLIDER_AUTOPLAY_RESUME_DELAY)
  }

  splide.on('mounted', () => {
    sliderEl.style.setProperty('--slider-speed', `${SLIDER_SPEED}ms`)
    sliderEl.style.setProperty(
      '--slider-scale-speed',
      `${SLIDER_SCALE_SPEED}ms`,
    )
    sliderEl.style.setProperty(
      '--slider-scale-delay',
      `${SLIDER_SCALE_DELAY}ms`,
    )
    applyEarlyScale(splide.index)

    // ドラッグ中は自動再生を止める / 終了後 SLIDER_AUTOPLAY_RESUME_DELAY 経過で再開
    splide.on('drag', () => {
      splide.Components.Autoplay?.pause(false)
    })
    splide.on('dragged', scheduleAutoplayResume)
    sliderEl.querySelectorAll('.splide__arrow').forEach((arrow) => {
      arrow.addEventListener('click', scheduleAutoplayResume)
    })
  })

  // 横移動が始まった瞬間に、行き先スライドの拡大を開始
  splide.on('move', (_newIndex, _prevIndex, destIndex) => {
    applyEarlyScale(destIndex)
  })

  splide.on('moved', () => {
    sliderEl.querySelectorAll('.splide__slide').forEach((slide) => {
      slide.classList.remove('is-scale-early')
    })
  })

  splide.mount()
}

document.addEventListener('DOMContentLoaded', initExhibitionSlider)
